import { firebaseAction } from "vuexfire";
import firebase from "firebase/app";

export default {
  namespaced: true,
  state: {
    list: [],
  },
  getters: {},
  mutations: {},
  actions: {
    //BINDINGS

    setList: firebaseAction(({ bindFirebaseRef }, ref) => {
      return new Promise((resolve) => {
        bindFirebaseRef("list", ref, {
          readyCallback() {
            resolve();
          },
        });
      });
    }),
    deleteNotification: function (context, { user, notification }) {
      return firebase
        .database()
        .ref("/notifications")
        .child(user[".key"])
        .child(notification[".key"])
        .remove();
    },
  },
};
